import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ThumbsUp, ThumbsDown, Eye } from 'lucide-react';
import type { TopContent } from '../../types/analytics';

interface TopContentTableProps {
  content: TopContent[];
  contentType: 'activity' | 'expert_tip';
  title: string;
}

export default function TopContentTable({ content, contentType, title }: TopContentTableProps) {
  const filtered = content
    .filter((c) => c.contentType === contentType)
    .sort((a, b) => a.rank - b.rank)
    .slice(0, 10);

  if (filtered.length === 0) {
    return (
      <Card className="bg-admin-dark-800 border-admin-slate-300/10">
        <CardHeader><CardTitle className="text-heading-5 text-admin-slate-400">{title}</CardTitle></CardHeader>
        <CardContent><p className="text-admin-slate-500 text-sm">No content data available.</p></CardContent>
      </Card>
    );
  }

  return (
    <Card className="bg-admin-dark-800 border-admin-slate-300/10">
      <CardHeader>
        <CardTitle className="text-heading-5 text-admin-slate-400">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-admin-slate-300/10">
                <th className="text-left py-2 px-3 text-admin-slate-500 font-medium">#</th>
                <th className="text-left py-2 px-3 text-admin-slate-500 font-medium">ID</th>
                <th className="text-right py-2 px-3 text-admin-slate-500 font-medium"><Eye className="w-4 h-4 inline" /></th>
                <th className="text-right py-2 px-3 text-admin-slate-500 font-medium"><ThumbsUp className="w-4 h-4 inline" /></th>
                <th className="text-right py-2 px-3 text-admin-slate-500 font-medium"><ThumbsDown className="w-4 h-4 inline" /></th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((item) => (
                <tr key={`${item.contentId}-${item.rank}`} className="border-b border-admin-slate-300/5 hover:bg-admin-dark-700/50">
                  <td className="py-2 px-3 text-admin-slate-500">{item.rank}</td>
                  <td className="py-2 px-3 text-admin-slate-400 font-medium">#{item.contentId}</td>
                  <td className="py-2 px-3 text-right text-admin-slate-400">{item.viewCount.toLocaleString()}</td>
                  <td className="py-2 px-3 text-right text-admin-accent-green">{item.likeCount}</td>
                  <td className="py-2 px-3 text-right text-admin-accent-red">{item.dislikeCount}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
}
